module.exports = __webpack_public_path__ + "static/media/battery-full.c05e049b.svg";